import { Pagination } from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import './styles.css';
import PedidoReembolsoCard from './PedidoReembolsoCard';
import { sxPagination } from './sxProps';
import { useNavigate } from 'react-router-dom';
import LoadingApp from '../../../../components/LoadingApp';
import ModalFeedBack from '../../../../components/ModalFeedBack';
import { PedidoReembolso } from '../../../../interfaces/entities/Reembolso/PedidoReembolso';
import { getReembolsoPagoPdf, getsolicitacoesprodutoexecutivo } from '../../../../services/Financeiro/ReembolsoService';
import { useAccessibility } from '../../../../Store/contexts/AccessibilityContext';
import { sxPaginationContrast } from '../../../../assets/styles/CommonSxProps';
import { scrollTo } from '../../../../utils/ScrollUtil';
import BackButton from '../../../../components/BackButton';
import RelatorioReembolsoForm from './RelatorioReembolsoForm';
import { base64toBlob } from '../../../../utils/Base64ToBlob';
import PageTitle from '../../../../components/Accessibility/PageTitle';

const MeusReembolsos = () => {
  const [reembolsos, setReembolsos] = useState<PedidoReembolso[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [modalFeedback, setmodalFeedback] = useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const navigate = useNavigate();
  
  const accessibility = useAccessibility();

  useEffect(() => {
    getReembolsos();
  }, [])

  const getReembolsos = async () => {
    setLoading(true);
    const response = await getsolicitacoesprodutoexecutivo();
    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: 'Falha ao buscar solicitações.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setLoading(false);
      return;
    }
    setReembolsos(response?.data);
    setLoading(false);
  };

  function handleGerarRelatorioClick({ dataInicio, dataFim }: { dataInicio: string; dataFim: string; }): void {
    setLoading(true);
    getReembolsoPagoPdf(dataInicio, dataFim)
      .then(pdf => {
        if (pdf) {
          const blob = base64toBlob(pdf.split(',')[1]);
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      })
      .catch(error => {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: error?.mensagem ? error.mensagem : 'Ocorreu um erro ao gerar o relatório.',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
      })
      .finally(() => {
        setLoading(false);
      })
  }

  const paginatedReembolsos = reembolsos.slice(
    (page - 1) * 5,
    page * 5
  );

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    scrollTo('scroll-ref');
  };

  const abrirDetalhe = (id: string, status: string, acessoReanalise: string) => {
    navigate("/financeiro/reembolso/meusReembolsos/" + id + "/" + status, {
      state: {
        acessoReanalise
      }
    });
  }

  return (
    <div className='meus-reembolsos-container'>
      <PageTitle text="Meus reembolsos" style={{marginBottom: '20px'}} />
      <RelatorioReembolsoForm 
          onDateChange={() => {}}
          onGerarRelatorioClick={handleGerarRelatorioClick}
        />
      <div className="meus-reembolsos-list">
        <LoadingApp showLoading={loading} />
        {reembolsos.length === 0 ?
          <h1 className='empty-reembolsos-info' style={accessibility.textStyleAccessibility}>Nenhuma solicitação cadastrada.</h1>
          :
          <div className="meus-reembolsos-cards-list">
            {paginatedReembolsos.length ? paginatedReembolsos.map((reembolso) => (
              <PedidoReembolsoCard
                key={reembolso.idPedidoReembolso}
                reembolso={reembolso}
                handleClickVerDetalhes={abrirDetalhe}
              />
            ))
              :
              <h1 className='empty-reembolsos-info' style={accessibility.textStyleAccessibility}>Nenhum reembolso encontrado.</h1>
            }
          </div>
        }
        {reembolsos.length > 5 &&
          <div className='pagination-holder'>
            <Pagination
              count={Math.ceil(reembolsos.length / 5)}
              sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} hideNextButton hidePrevButton
              color='primary'
              page={page}
              onChange={handlePageChange}
            />
          </div>
        }

        <BackButton route={'/financeiro/reembolso'} ariaLabel="voltar para menu do reembolso"/>
      </div>
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
      />
    </div>
  )
}

export default MeusReembolsos